import Vue from 'vue';
import VueRouter from 'vue-router';
import {RoutsData} from '@/router/routs';
import Login from '@/views/Login.vue';
import {RouterContext} from '@/router/router-context';
import middlewarePipeline from '@/router/middleware/middleware-pipeline';
import store from '@/store';
import refreshCurrentUser from '@/router/middleware/refresh-current-user';
import EmptyRouterView from '@/views/EmptyRouterView.vue';
import isAdmin from '@/router/middleware/is-admin';

Vue.use(VueRouter);

const routes = [
  {
    name: RoutsData.LOGIN.name,
    path: RoutsData.LOGIN.path,
    component: Login
  },
  {
    path: RoutsData.USER_ROOT.path,
    name: RoutsData.USER_ROOT.name,
    meta: {middleware: [refreshCurrentUser, isAdmin]},
    component: EmptyRouterView,
    children:[
      {
        path: '',
        redirect: {name: RoutsData.USER_LIST.name}
      },
      {
        path: RoutsData.USER_LIST.path,
        name: RoutsData.USER_LIST.name,
        meta: {middleware: [refreshCurrentUser, isAdmin]},
        component: () => import('../views/UserList.vue'),
      }
    ]
  },
  {
    path: RoutsData.COMPANY_ROOT.path,
    name: RoutsData.COMPANY_ROOT.name,
    meta: {middleware: [refreshCurrentUser, isAdmin]},
    component: () => import('../views/InitiatorList.vue'),
  },
  {
    path: RoutsData.EVENT_ROOT.path,
    meta: {middleware: [refreshCurrentUser]},
    component: EmptyRouterView,
    children: [
      {
        path: RoutsData.EVENT_LIST.path,
        name: RoutsData.EVENT_LIST.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/EventsList.vue'),
      },
      {
        path: RoutsData.EVENT_ADD.path,
        name: RoutsData.EVENT_ADD.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/Event.vue'),
      },
      {
        path: RoutsData.EVENT_SHOW_ROOT.path,
        name: RoutsData.EVENT_SHOW_ROOT.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/Event.vue'),
      },
      {
        path: '',
        name: RoutsData.EVENT_ROOT.name,
        redirect: {name: RoutsData.EVENT_LIST.name}
      },
    ]
  },
  {
    path: RoutsData.CHANNEL_ROOT.path,
    name: RoutsData.CHANNEL_ROOT.name,
    meta: {middleware: [refreshCurrentUser, isAdmin]},
    component: EmptyRouterView,
    children: [
      {
        path: '',
        redirect: {name: RoutsData.CHANNEL_LIST.name}
      },
      {
        path: RoutsData.CHANNEL_LIST.path,
        name: RoutsData.CHANNEL_LIST.name,
        meta: {middleware: [refreshCurrentUser, isAdmin]},
        component: () => import('../views/ChannelList.vue'),
      },
      {
        path: RoutsData.CHANNEL_ADD.path,
        name: RoutsData.CHANNEL_ADD.name,
        meta: {middleware: [refreshCurrentUser, isAdmin]},
        component: () => import('../views/Channel.vue'),
      },
      {
        path: RoutsData.CHANNEL.path,
        name: RoutsData.CHANNEL.name,
        meta: {middleware: [refreshCurrentUser, isAdmin]},
        component: () => import('../views/Channel.vue'),
      },
    ]
  },
  {
    path: RoutsData.VIDEO_CHANNEL_ROOT.path,
    meta: {middleware: [refreshCurrentUser]},
    component: EmptyRouterView,
    children: [
      {
        path: '',
        name: RoutsData.VIDEO_CHANNEL_ROOT.name,
        redirect: {name: RoutsData.VIDEO_CHANNEL_LIST.name}
      },
      {
        path: RoutsData.VIDEO_CHANNEL_LIST.path,
        name: RoutsData.VIDEO_CHANNEL_LIST.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/VideoChannelList.vue'),
      },
      {
        path: RoutsData.VIDEO_CHANNEL_ADD.path,
        name: RoutsData.VIDEO_CHANNEL_ADD.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/VideoChannel.vue'),
      },
      {
        path: RoutsData.VIDEO_CHANNEL.path,
        name: RoutsData.VIDEO_CHANNEL.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/VideoChannel.vue'),
      },
    ]
  },
  {
    path: RoutsData.VIDEO_ROOT.path,
    component: EmptyRouterView,
    meta: {middleware: [refreshCurrentUser]},
    children: [
      {
        path: '',
        name: RoutsData.VIDEO_ROOT.name,
        redirect: {name: RoutsData.VIDEO_LIST.name}
      },
      {
        path: RoutsData.VIDEO_LIST.path,
        name: RoutsData.VIDEO_LIST.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/VideoList.vue'),
      },
      {
        path: RoutsData.VIDEO_ADD.path,
        name: RoutsData.VIDEO_ADD.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/Video.vue'),
      },
      {
        path: RoutsData.VIDEO.path,
        name: RoutsData.VIDEO.name,
        meta: {middleware: [refreshCurrentUser]},
        component: () => import('../views/Video.vue'),
      },
    ]
  },
  {
    name: RoutsData.TICKET_CATEGORY.name,
    path: RoutsData.TICKET_CATEGORY.path,
    meta: {middleware: [refreshCurrentUser]},
    component: () => import('../views/TicketCategoryList.vue'),
  },
  {
    path: RoutsData.DEFAULT.path,
    name: RoutsData.DEFAULT.name,
    redirect: {name: RoutsData.EVENT_LIST.name}
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  if (!to.meta.middleware) {
    return next();
  }

  const middleware = to.meta.middleware;

  const context: RouterContext = {
    to,
    from,
    next,
    store
  };

  return middleware[0]({
    ...context,
    next: middlewarePipeline(context, middleware, 1)
  });

});

export default router;
